import { useEffect, useState } from "react";

const useCopyContent = () => {
  const [showCheckMark, setShowCheckMark] = useState(false);

  useEffect(() => {
    if (!showCheckMark) {
      return;
    }

    const timeoutId = setTimeout(() => {
      setShowCheckMark(false);
    }, 3000);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [showCheckMark]);

  return [showCheckMark, setShowCheckMark];
};

export default useCopyContent;
